import { fetchCookie } from "./FetchCookie";

export const fetchUserRole = async (callback, navigate) => {
  try {
    const userData = await fetchCookie();
    const role = userData?.user?.user_type;
    console.log("role", role);
    callback(role);
  } catch (error) {
    console.error("Error fetching user role:", error);
    navigate("/login"); // Redirect in case of an error
  }
};


export const getUserRole = async () => {
    try {
      const userData = await fetchCookie();
      return userData?.user?.user_type;
    } catch (error) {
      console.error("Error fetching user role:", error);
      return null;
    }
  };